/** Class joiner (no tailwind-merge dependency; keep class order intentional). Ported from runebound.gg. */
export function cn(...classes: (string | false | null | undefined)[]): string {
  return classes.filter(Boolean).join(' ');
}
